export const CA_PROVINCES = [
  ["AB", "Alberta"], ["BC", "British Columbia"], ["MB", "Manitoba"], ["NB", "New Brunswick"], ["NL", "Newfoundland and Labrador"],
  ["NS", "Nova Scotia"], ["NT", "Northwest Territories"], ["NU", "Nunavut"], ["ON", "Ontario"], ["PE", "Prince Edward Island"],
  ["QC", "Quebec"], ["SK", "Saskatchewan"], ["YT", "Yukon"],
];

export const CA_CITIES = {
  AB: ["Calgary", "Edmonton", "Red Deer", "Lethbridge", "Medicine Hat", "Grande Prairie", "Airdrie", "Fort McMurray", "St. Albert", "Sherwood Park"],
  BC: ["Vancouver", "Surrey", "Burnaby", "Richmond", "Victoria", "Kelowna", "Abbotsford", "Langley", "Kamloops", "Nanaimo", "Coquitlam", "Prince George"],
  MB: ["Winnipeg", "Brandon", "Steinbach", "Thompson", "Portage la Prairie"],
  NB: ["Moncton", "Saint John", "Fredericton", "Dieppe", "Miramichi"],
  NL: ["St. John's", "Mount Pearl", "Corner Brook", "Conception Bay South", "Paradise"],
  NS: ["Halifax", "Dartmouth", "Sydney", "Truro", "New Glasgow"],
  NT: ["Yellowknife", "Hay River", "Inuvik"],
  NU: ["Iqaluit", "Rankin Inlet"],
  ON: ["Toronto", "Ottawa", "Mississauga", "Brampton", "Hamilton", "London", "Markham", "Vaughan", "Kitchener", "Windsor", "Richmond Hill", "Oakville", "Burlington", "Oshawa", "Barrie", "St. Catharines", "Guelph", "Kingston", "Sudbury", "Thunder Bay"],
  PE: ["Charlottetown", "Summerside", "Stratford"],
  QC: ["Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke", "Saguenay", "Lévis", "Trois-Rivières", "Terrebonne", "Brossard", "Repentigny"],
  SK: ["Saskatoon", "Regina", "Prince Albert", "Moose Jaw", "Swift Current"],
  YT: ["Whitehorse", "Dawson City"],
};

export const COUNTRIES = [["US", "United States"], ["CA", "Canada"]];
